// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconCheckCircleSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 38 58"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.663 18.125a11.791 11.791 0 00-8.335 3.45 11.778 11.778 0 008.335 20.113c3.127 0 6.125-1.242 8.336-3.451a11.778 11.778 0 00-8.336-20.112zm-13.6 11.781a13.588 13.588 0 018.396-12.559 13.607 13.607 0 0117.77 7.357 13.588 13.588 0 01-2.948 14.815 13.605 13.605 0 01-19.235 0 13.59 13.59 0 01-3.984-9.613zm19.757-3.975l-6.075 7.807a1.814 1.814 0 01-1.433.7h-.934a1.814 1.814 0 01-1.414-.68l-3.355-4.193 1.414-1.13 3.355 4.19h.934l6.076-7.806 1.432 1.112z"
      />
    </svg>
  )
}
